import { render, staticRenderFns } from "./IssuePilotlessSeafaring.vue?vue&type=template&id=55bac6f0"
import script from "./IssuePilotlessSeafaring.vue?vue&type=script&lang=ts"
export * from "./IssuePilotlessSeafaring.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports